import { apiSlice } from "app/api/apiSlice";

export const AggregationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAggregationFpo: builder.mutation({
      query: (payload) => ({
        url: `procurement-v2/api/aggregation`,
        method: "POST",
        body: payload,
      }),
    }),
    getAllFarmersInCrop: builder.query({
      query: (selectedCrop) =>
        `procurement-v2/api/aggregation/?crop_name=${selectedCrop}`,
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getFarmerAggrigationById: builder.query({
      query: (id) => `procurement-v2/api/aggregation/?id=${id}`,
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    createAggregationFarmerStock: builder.mutation({
      query: (payload) => ({
        url: `procurement-v2/api/farmer-stock`,
        method: "POST",
        body: payload,
      }),
    }),
    getAggregationFarmerStock: builder.query({
      query: (aggrigationId) =>
        `procurement-v2/api/farmer-stock/?aggregation_id__id=${aggrigationId}`,
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    updateAggregationByFarmer: builder.mutation({
      query: ({ id, payload }) => ({
        url: `procurement-v2/api/farmer-stock/${id}`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const {
  useCreateAggregationFpoMutation,
  useGetAllFarmersInCropQuery,
  useGetFarmerAggrigationByIdQuery,
  useCreateAggregationFarmerStockMutation,
  useGetAggregationFarmerStockQuery,
  useUpdateAggregationByFarmerMutation,
} = AggregationApiSlice;
